var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'MainGroupbuyingsList'
      }
    }
  }, [_vm._v("總公司團購管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("下單數量設定")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v("下單數量設定")]), _c('div', {
    staticClass: "mb-4"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "content-cols": "12",
      "content-cols-lg": "7",
      "label-size": "sm",
      "label": "請輸入商品編號，輸入完畢後，請按確認"
    }
  }, [_c('div', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入商品編號"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearchProducts.apply(null, arguments);
      }
    },
    model: {
      value: _vm.code,
      callback: function callback($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.code
    },
    on: {
      "click": _vm.handleSearchProducts
    }
  }, [_vm._v("確認")])], 1)], 1), _c('ProductViewer', {
    attrs: {
      "loading": _vm.isFetchProduct,
      "product": _vm.selectedProduct
    }
  })], 1)])], 1), _vm.selectedProduct ? _c('div', [_c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "商品可賣量",
      "label-for": "input-1"
    }
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.salableQuantity) + " ")])]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最高購買數",
      "label-for": "once_max_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_max_quantity",
      "type": "number",
      "readonly": "true",
      "formatter": function formatter(value) {
        return value < 0 ? 0 : Math.round(value);
      },
      "state": _vm.v$.form.once_max_quantity.$error ? false : null
    },
    model: {
      value: _vm.form.once_max_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_max_quantity", $$v);
      },
      expression: "form.once_max_quantity"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最低購買數",
      "label-for": "once_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      },
      "state": _vm.v$.form.once_quantity.$error ? false : null
    },
    model: {
      value: _vm.form.once_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_quantity", $$v);
      },
      expression: "form.once_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.once_quantity.less.$invalid
    }
  }, [_vm._v(" 需小於每人最高購買數 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下單數量遞增數",
      "label-for": "once_increase_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_increase_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      },
      "state": _vm.v$.form.once_increase_quantity.$error ? false : null
    },
    model: {
      value: _vm.form.once_increase_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_increase_quantity", $$v);
      },
      expression: "form.once_increase_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.once_quantity.less.$invalid
    }
  }, [_vm._v(" 『每人最低購買數+下單數量遞增數』不能高於『每人最高購買數』 ")])], 1)], 1) : _vm._e()]), _vm.selectedProduct ? [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-group', {
    staticClass: "items-center",
    attrs: {
      "label": ""
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "radio-group-1",
      "name": "radio-options"
    },
    on: {
      "change": _vm.getGroupbuyingByProduct
    },
    model: {
      value: _vm.groupbuyingStatusFilterValue,
      callback: function callback($$v) {
        _vm.groupbuyingStatusFilterValue = $$v;
      },
      expression: "groupbuyingStatusFilterValue"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": "waiting"
    }
  }, [_vm._v("準備中")]), _c('b-form-radio', {
    attrs: {
      "value": "waiting|going"
    }
  }, [_vm._v("準備中 / 開團中")])], 1)], 1)], 1), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "justify-content-md-center"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger",
      "disabled": _vm.isSubmmiting || _vm.groupbuyingStatusFilterValue !== 'waiting' || _vm.groupbuying.length === 0
    },
    on: {
      "click": _vm.handleDeleteGroupbuy
    }
  }, [_vm._v("刪除")]), _c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "success",
      "disabled": !_vm.selectedProduct || _vm.isSubmmiting || _vm.total === 0
    },
    on: {
      "click": _vm.handleUpdateCache
    }
  }, [_vm._v("更新商說頁快取")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.selectedProduct || _vm.isSubmmiting || _vm.total === 0
    },
    on: {
      "click": _vm.handleSubmitGroupbuy
    }
  }, [_vm._v("更新下單數量設定")])], 1)]), _c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("共 " + _vm._s(_vm.total) + " 團")])])]), _c('div', {
    staticClass: "col-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.groupbuying,
      "fields": _vm.fields,
      "busy": _vm.isFetchGroupbuyList
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(groupbuying_number)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'GroupbuyingsDetail',
              params: {
                groupbuyID: data.item.id
              }
            }
          }
        }, [_vm._v(_vm._s(data.item.groupbuying_number) + " ")])];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(_vm._s(_vm.getStatusName(data.item.status)))])];
      }
    }, {
      key: "cell(title)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'MainGroupbuyingsDetail',
              params: {
                groupbuyID: data.item.id
              }
            }
          }
        }, [_c('div', [_vm._v(" " + _vm._s(data.item.products[0] && data.item.products[0].title) + " ")]), _c('div', {
          staticClass: "mb-1"
        }, [_vm._v(" " + _vm._s(data.item.products[0] && data.item.products[0].sale_page_code) + " ")])])];
      }
    }, {
      key: "cell(picture)",
      fn: function fn(data) {
        return [data.item.products[0] && data.item.products[0].image_list && data.item.products[0].image_list[0].pic_url ? _c('b-img-lazy', {
          staticClass: "thumb-image",
          attrs: {
            "src": data.item.products[0] && data.item.products[0].image_list[0].pic_url,
            "alt": "商品圖片",
            "width": "50",
            "height": "50"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(branch_name)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(" " + _vm._s(data.item.group.branch.name) + " ")]), _c('div', {
          staticClass: "mt-1"
        }, [_vm._v(" " + _vm._s(data.item.group.branch.branch_code) + " ")])];
      }
    }, {
      key: "cell(group)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "mb-1"
        }, [_vm._v(" " + _vm._s(data.item.group.name) + " ")]), _c('div', [_vm._v(" " + _vm._s(data.item.group.group_number) + " ")])];
      }
    }, {
      key: "cell(date)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "mb-1"
        }, [_vm._v(" " + _vm._s(_vm.format(new Date(data.item.start_at), "yyyy-MM-dd HH:mm")) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.format(new Date(data.item.end_at), "yyyy-MM-dd HH:mm")) + " ")])];
      }
    }], null, false, 3780306911)
  })], 1)] : _vm._e()], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }